
let NOOP = () => {};

export default script => {
  
}